import { IFProjectState } from './InterfacesState';

export const StubCalc = {
  partner: '',
  price: [],
  townto: '',
  errormsg: '',
};

export const ProjectState: IFProjectState = {
  header: { menu: [] },
  alert: [],
  stories: [],
  calculator: {
    KurDalli: StubCalc,
    KurSdek: StubCalc,
    PvzBoxberry: StubCalc,
    PvzSdek: StubCalc,
    Pvz5post: StubCalc,
    RuPost: StubCalc,
  },
  vacancies: [],
  widthWindow: window.innerWidth,
  offsetContent: 0,
  blog: [],
  blogMain: [],
  blogPopular: [],
  logosPartners: [],
  advantagesSlider: [],
  advantagesSliderTitle: 'За что нас выбирают',
  reviews: [],
  about: {
    titleFaces: 'Dalli в лицах',
    employees: [],
    pageVacancies: {
      image: '',
      title: 'Вакансии',
      subTitle: 'Ждем вас в команде Dalli',
    },
  },
  state404: false,
  blockedSend: { state: false, counter: '00:00' },
  recaptchaV2ref: null,
  textCards: {title: '', items: []},
  iconCards: {title: '', items: []},
  contactForms: {
    title: 'Станьте участником клуба доставки Dalli',
    main_contact_form_id: 0,
    new_contact_form_id: 0,
    vacancy_contact_form_id: 0,
    modal_contact_form_id: 0,
    ask_question_contact_form_id: 0
  }
};
